import { liteClient } from 'algoliasearch/lite';
import { SearchMethodParams, SearchResponses } from 'algoliasearch';

const algoliaClient = liteClient(process.env.NEXT_PUBLIC_ALGOLIA_APP_ID || '', process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY || '');

export const searchClient = {
  search: async (requests: SearchMethodParams['requests']): Promise<SearchResponses> => algoliaClient.search(requests),
  searchForFacets: algoliaClient.searchForFacets,
};
